import { render } from "./NotFoundComponent.vue?vue&type=template&id=5498c2a6&scoped=true"
import script from "./NotFoundComponent.vue?vue&type=script&lang=js"
export * from "./NotFoundComponent.vue?vue&type=script&lang=js"

import "./NotFoundComponent.vue?vue&type=style&index=0&id=5498c2a6&scoped=true&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5498c2a6"]])

export default __exports__